export default __webpack_public_path__ + "static/media/1052.23d95d6b.svg";